import React from "react";
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Posts from "./Posts";

const AdminPanel = ( props ) => {
    return(
        <Grid container>
            <Grid item container xs={9} direction="column">
                <Grid item>
                    <Link to={`/admin/authors/${props.username}`}>
                        <h1>Hello {props.username}</h1>
                    </Link>
                    <h1>All Posts</h1>
                </Grid>
                <Grid item>
                    <Posts username={props.username} />
                </Grid>
            </Grid>
            <Grid item container xs={3} direction="column">
                <h1>Side Bar</h1>
                <Link to="/admin/compose">
                    <Button
                        endIcon={<AddIcon />} 
                        variant="outlined"   
                    >
                        New Blog
                    </Button>
                </Link>
            </Grid>
        </Grid>
    );
}

export default AdminPanel;